import react, { useState } from "react";
import { useNavigate } from "react-router-dom";

const GuideDashboardHeader = () => {

    const [navOpen, setNavOpen] = useState(false);

    const navigate = useNavigate();

    const handleLogoClick = () => {
        window.open("/phone", "_self");
    }

    const logOut = () => {
        const response = fetch(`${process.env.REACT_APP_API_URL}/guide/logout`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                token: window.localStorage.getItem('guideToken'),
                token_expiry: window.localStorage.getItem('guideTokenExpiry')
            }),
          })
          .then(response => response.json())
          .then(data => {
               // Handle successful logout
                window.localStorage.removeItem('guideToken');
                window.localStorage.removeItem('guideTokenExpiry');
                navigate("/");
                console.log("guide logged out successfully");
          })
          .catch(error => {
              console.error("Error occurred during guide logout:", error);
          });
    }

    return (
        <header className="mobile-header">
            <div className="header-row">
                <img
                    onClick={handleLogoClick}
                    src="https://buckish-ghosted-maps.s3.us-west-1.amazonaws.com/boggler-logo-clear.png"
                    alt="Boggler Logo"
                    className="header-logo"
                    loading="lazy"
                    style={{ borderRadius: 8 }}
                />
            <button
                className="hamburger"
                aria-label="Open navigation"
                onClick={() => setNavOpen(!navOpen)}
            >
                <span className="bar" />
                <span className="bar" />
                <span className="bar" />
            </button>
            </div>
            <nav className={`main-nav${navOpen ? " open" : " closed"}`}>
                <span className="header-button header-button-contact" onClick={() => navigate("/profile", "_self")}>Profile</span>
                {/* <span className="header-button header-button-contact" onClick={handleConversationsClick}>Conversations</span> */}
                {/* <span className="header-button header-button-contact" onClick={() => navigate("/dmdilly", "_self")}>DM Dilly</span> */}
                <span className="header-button header-button-contact" onClick={() => navigate("/phone", "_self")}>Phone</span>
                <span className="header-button header-button-contact" onClick={() => navigate("/manage-finances", "_self")}>Finances</span>
                <span onClick={logOut} className="header-button header-button-buckish">Logout</span>
            </nav>
        </header>
    )
}

export default GuideDashboardHeader;